import { render, staticRenderFns } from "./ClientMedicalInfo.vue?vue&type=template&id=59e63e70"
import script from "./ClientMedicalInfo.vue?vue&type=script&lang=js"
export * from "./ClientMedicalInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports